    
    function getDateTimeStamp(dateStr){
        return Date.parse(dateStr.replace(/-/gi,"/"));
    }

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    function getDateDiff(dateTimeStamp){
        var now = new Date().getTime();
        var _year = new Date().getFullYear();
        var _year_time = new Date(dateTimeStamp).getFullYear();
        var diffValue = now - new Date(dateTimeStamp).getTime();
        if(diffValue < 0){
            alert("结束日期不能小于开始日期！");
        }
        var monthC =diffValue/month;
        var weekC =diffValue/(7*day);
        var dayC =diffValue/day;
        var hourC =diffValue/hour;
        var minC =diffValue/minute;
        var result;
        if(_year !== _year_time){
            result=""+dateTimeStamp.substring(0,10)+'';
        }else if(dayC>=1){
            result=""+dateTimeStamp.substring(5,10)+'';
        }else if(hourC>=1){
            result=""+ parseInt(hourC) +"小时前";
        }else if(minC>=1){
            result=""+ parseInt(minC) +"分钟前";
        }else{
            result="刚刚";
        }
        return result;
    }
    
export default getDateDiff;

